import Vue from "vue";

Vue.component("bo-announcement-bar", require("@/v2/components/bo-announcement-bar.vue").default);

new Vue({
    el: "#announcement-div",
    name: "announcement-div",
    data() {
        return {};
    },
});
